import React from "react";
import "../MainPage.css";
import { Col, Row } from "react-bootstrap";

function ModuleCards(props) {
    /**
     * Generates grid of module cards containing thumbnail and description text (max of 5 lines are shown).
     * Each card is linked to their corresponding Action Byte.
     * @param props: action byte list to map over when generating the cards
     * @returns: module cards in the form of a grid (3 columns for large screens, 2 columns for medium screens, variable for smaller ones)
     */
    props.actionBytesList.sort((a, b) => {
        return new Date(b["date"]) - new Date(a["date"]);
    })

    // Map over the filtered action byte list and create a module card for each one. Set column number to 3 for large viewports, 2 for medium viewports, and "auto" for smaller ones.
    return (
        <Row className="justify-content-center" lg={1} md={1} sm={1} xs={1}>
            {props.actionBytesList.map(actionByte => {
                return (
                    <Col>
                        <a href={actionByte["link"]} target="_blank" rel="noopener noreferrer">
                            <div className="d-inline-block py-2 px-2" style={{width: "100%"}}>
                                <div className="action-byte-card card">
                                    <div className="img-div">
                                        <img src={actionByte["thumbnail"]} alt={`A representation of ${actionByte["title"]}`}></img>
                                    </div>
                                    
                                    <div className="card-body p-2">
                                        <h5 className="head-sport card-title text-center overflow-hidden" style={{margin: 0, maxHeight: "25%"}}>{actionByte["title"]}</h5>
                                        <p className="card-text text-white overflow-hidden" style={{maxHeight: "60%"}}>{actionByte["text"]}</p>
                                        <p className="card-text text-white" style={{position: 'absolute', bottom: 0, right: 0, padding: 10, margin: 0}}>Publication Date: {actionByte["date"]}</p>
                                        <div className="click-indicator">View ➤</div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </Col>
                );
            })}
        </Row>
    );
}

export default ModuleCards;